import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IVisitorPotentialValuesPayloadState extends ISagaCb {}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const visitorPotentialValuesSlice = createSlice({
    name: 'company-statistics/visitor-potential-values',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IVisitorPotentialValuesPayloadState>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const visitorPotentialValuesActions = visitorPotentialValuesSlice.actions
export default visitorPotentialValuesSlice.reducer
